module.exports = __webpack_public_path__ + "img/fork-and-knife-with-plate.a7d5903d.png";